import { useContext, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { UserContext } from '@adflow/utils';
import { resolveContentStudioAdvertiserId } from '../utils/resolveContentStudioAdvertiserId';
import { ContentStudioOverlay } from './ContentStudioOverlay';

export function Index() {
  const { user } = useContext(UserContext);
  const navigate = useNavigate();
  const advertiserId = useMemo(() => resolveContentStudioAdvertiserId(user), [user]);

  return (
    <ContentStudioOverlay
      user={user}
      context={{
        source: 'creative-hub-nav',
        ...(advertiserId ? { advertiserId } : {}),
      }}
      onClose={() => navigate('/templates')}
    />
  );
}
